<template>
  <div
    data-component-group="business-form"
    data-component="business-contacts"
    class="elevation-1"
  >
    <slot name="beforeForm" />

    <v-list lines="two" class="business-contacts-list">
      <template v-for="businessContact in items" :key="businessContact.id">
        <router-link
          :to="`/users/${businessContact.id}`"
          class="trigger view-user"
          target="_blank"
        >
          <v-list-item class="business-contact-item">
            <!--<v-list-item-avatar>-->
            <v-avatar>
              <v-icon>account_circle</v-icon>
            </v-avatar>


              {{ `${businessContact.firstname} ${businessContact.lastname}` }}

          </v-list-item>
        </router-link>
      </template>
    </v-list>
  </div>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        required: true,
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='business-form'] {
  &[data-component='business-contacts'] {
    background-color: map.get($colors, shades, 'white');
    padding: 16px;

    .trigger.view-user {
      text-decoration: none;
    }
  }
}
</style>
